export const isIframeContext = () => {
  try {
    return window.self !== window.top;
  } catch {
    return false;
  }
};

export const getConversationIdFromRoute = route => {
  const { params = {}, name } = route || {};

  if (params.conversationId || params.conversation_id) {
    return params.conversationId || params.conversation_id;
  }

  if (name === 'inbox_view_conversation' && params.type === 'conversation') {
    return params.id;
  }

  return null;
};

export const isEmbeddedConversationMode = route => {
  return isIframeContext() && !!getConversationIdFromRoute(route);
};
